<template>
  <div
    class="select_box"
    :class="{
      'select_box--out_of_stock': isOutOfStock
    }"
    @click="selectRadioBtn"
  >
    <p
      :class="{
        select_box_label: !isSelected,
        'select_box_label--selected': isSelected
      }"
    >
      <span class="select_box_span">
        {{ label }}
      </span>
    </p>
    <p v-if="isOutOfStock" class="select_box--out_of_stock--text">
      入荷待ち
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    isOutOfStock: {
      type: Boolean,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    selectRadioBtn() {
      this.$emit('input', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
// select box
.select_box {
  padding-right: 8px;

  &:last-of-type {
    padding-right: 0;
  }

  .select_box_span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-all;
    color: $black;
    text-align: center;
    line-height: 1.6;
    font-size: 1.4rem;
    font-weight: bold;
  }

  .select_box_label {
    @extend %hover-common;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 76px;
    height: 34px;
    padding: 16px;
    cursor: pointer;
    border: 2px solid $gray-2;
    border-radius: 8px;

    &--selected {
      @extend .select_box_label;
      border: 2px solid $black;
    }
  }

  &--out_of_stock {
    input[type='radio'] + label {
      border: 2px solid $gray-2;
    }

    .select_box_label {
      background-color: $gray-2;

      &:hover {
        opacity: 1;
      }
    }

    .select_box_span {
      color: $gray-1;
    }

    &--text {
      padding-top: 8px;
      text-align: center;
      color: $danger;
      font-size: 1.2rem;
    }
  }
}
</style>
